import { computedFrom } from 'aurelia-framework';

export class Tenant {
    containerName: string;
    created: Date;
    id: string;
    isActive: boolean;
    name: string;
    notes: string;
    modified: Date;
    subDomain: string;

    settings: Array<TenantSetting>;

    get enqueueTransactions(): boolean {
        const setting = this.settings.find((setting): boolean => setting.name === "EnqueueTransactions") as TenantSetting;
        return setting ? Boolean(setting.value) : false;
    }
}

export class TenantSetting {

    constructor(name: string, value: string) {
        this.name = name;
        this.value = value;
    }

    id: string;
    isActive: string;
    name: string;
    value: string;
    type: string;
    tenantId: string;
    modified: Date;
}